import { toast } from "react-toastify";
import {
  fetchCreateSORequest,
  fetchCreateSOSuccess,
  fetchCreateSOFailure,
} from "./reducer";

import { CREATE_SO } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const createSO =
  (jsonObj, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchCreateSORequest());

    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        CREATE_SO,
        "POST",
        jsonObj,
      );

      if (response?.error) {
        dispatch(fetchCreateSOFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchCreateSOSuccess(response));
        dispatch(setSuccessMessage(true));
        toast.success("Sales Order recorded Successfully");
        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(fetchCreateSOFailure("Something went wrong"));

      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
